import httpClient from 'shared/lib/httpClient';
import { parseProvinceList } from '../schemas/MasterDataSchema';

export const getProvinceList = async (params) => {
  const response = await httpClient.get('/provinces', { params });
  return parseProvinceList(response?.data);
};
